import { makeGqlQuery } from '@/utilities/gqlQuery';
import { type ResultOf, gql } from '@/utilities/gql';

const QUERY = gql(
  `
	query CompanySummary($canonicalUrl: String!) {
		Company(canonicalURL: $canonicalUrl) {
			id
			canonicalURL
			isSearchable
			classificationStatus
			dateGenerated
			exchangeCountryISO
			media {
				url
			}
			data {
				info
			}
			analysisMisc {
				isFund
			}
			analysisValue {
      	preferredMultiple: preferredRelativeMultiple
    	}
			score {
				dividend
				future
				health
				past
				value
			}
			info {
     		hasLogo
    	}
		}
	}
`
);

/**
 * Return a company report summary info
 *
 * @param companyId
 *
 */
export const useFetchCompanySummary = makeGqlQuery(QUERY);

export type CompanySummary = ResultOf<typeof QUERY>;
